import { useNavigate } from 'react-router-dom'

/**
 * Hace que una fila de listado se comporte como un link de verdad.
 *
 * Las filas navegan con JavaScript (`onClick` en el `<tr>`), y eso rompe tres
 * cosas que la gente da por sentadas en cualquier lista: **Ctrl+click**,
 * **click del medio** y **click derecho → abrir en pestaña nueva**. Sin ellas
 * no se puede abrir varios documentos para procesarlos en serie, que es como
 * trabaja ventas.
 *
 * Devuelve los props del `<tr>`: click normal navega en la misma pestaña,
 * Ctrl/⌘+click y click del medio abren en una nueva.
 *
 * OJO — el **click derecho** necesita un `<a href>` de verdad abajo del cursor:
 * ningún manejador de JavaScript puede agregarle opciones al menú del
 * navegador. Por eso el número del documento se dibuja aparte con `<Link>`
 * (ver `LinkDoc`), y ahí el click derecho sí ofrece abrir en pestaña nueva.
 */
export function useFilaLink(path) {
  const navigate = useNavigate()

  return {
    onClick: (e) => {
      // Ctrl (Windows/Linux) o ⌘ (Mac) → pestaña nueva, sin robarle el foco.
      if (e.ctrlKey || e.metaKey) {
        window.open(path, '_blank', 'noopener')
        return
      }
      navigate(path)
    },
    // Botón del medio. Se frena el default para que el navegador no active el
    // scroll automático encima de la pestaña que acabamos de abrir.
    onAuxClick: (e) => {
      if (e.button === 1) {
        e.preventDefault()
        window.open(path, '_blank', 'noopener')
      }
    },
    style: { cursor: 'pointer' },
    title: 'Abrir — Ctrl+click o botón del medio para una pestaña nueva',
  }
}
